import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('./../App'),
    children: [
      {
        path: '/404/:catchAll(.*)',
        component: () => import('../views/Error404View'),
        name: 'not_found',
        meta: {
          title: 'Page not found'
        },
      },
      {
        path: '/:catchAll(.*)',
        name: 'check_slug',
        component: () => import('./../views/CheckSlugView')
      }
    ]
  },

  {
    path: '*',
    props: route => ({ query: route.query }),
    redirect: { name: 'not_found' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
